export const Skeleton = () => {
  return (
    <div role="status" className="max-w-sm animate-pulse p-3">
      <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-2"></div>
      <div className="bg-gray-100 rounded-md dark:bg-gray-700 w-full h-14 mb-2.5"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export const FormSkeleton = () => {
  return (
    <div role="status" className="max-w-screen-md m-auto animate-pulse p-3 min-h-screen">
      <div className="bg-gray-300 rounded-md dark:bg-gray-700 w-full h-64 mb-2.5"></div>
      <div className="bg-gray-100 rounded-md dark:bg-gray-700 w-full h-14 mb-2.5"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-14 mb-2.5"></div>
      <div className="bg-gray-100 rounded-md dark:bg-gray-700 w-full h-14 mb-2.5"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-14 mb-2.5"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export const ListSkeleton = () => {
  return (
    <div role="status" className="max-w-screen-md m-auto animate-pulse p-3 grid gap-3 w-full">
      <div className="bg-gray-300 rounded-md dark:bg-gray-700 w-full h-20"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-20"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-20"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-20"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export const FiltersSkeleton = () => {
  return (
    <div role="status" className="max-w-screen-md m-auto animate-pulse p-3 grid gap-3 w-full">
      <div className="bg-gray-300 rounded-md dark:bg-gray-700 w-24 h-6"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-8"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-8"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-8"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-8"></div>
      <div className="bg-gray-300 rounded-md dark:bg-gray-700 w-24 h-6"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-8"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-8"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-8"></div>
      <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-8"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export const DashboardSkeleton = () => {
  return (
    <div role="status" className="max-w-screen-xl m-auto animate-pulse p-3 grid gap-3 w-full">
      <div className="bg-gray-300 rounded-md dark:bg-gray-700 w-56 h-16"></div>
      <div role="status" className="grid md:grid-cols-2 gap-3 w-full">
        <div className="bg-gray-300 rounded-md dark:bg-gray-700 w-full h-52 md:h-80"></div>
        <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-52 md:h-80"></div>
        <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-52 md:h-80"></div>
        <div className="bg-gray-200 rounded-md dark:bg-gray-700 w-full h-52 md:h-80"></div>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};
